import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import {environment} from '../environments/environment';
import { BaseURLService } from '../shared/util/baseUrl.service';
import { BrowserAuthOptions } from '@azure/msal-browser';

export interface adDetailsObject {
    success: boolean;
    production: boolean;
    adTenantId?: string;
    adClientId: string
    adRedirectUri: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private settings: Partial<adDetailsObject>;
  private http: HttpClient;
  private appBaseURL: string;

  constructor(private readonly httpHandler: HttpBackend, private baseHref:BaseURLService) {
    this.http = new HttpClient(httpHandler);
  }

  init(): Promise<boolean> {
    this.appBaseURL = this.baseHref.get();
    return new Promise<boolean>((resolve, reject) => {
      const endpoint =  window.location.hostname === "localhost" ? "http://localhost:3000/auth/adDetails" :`${this.appBaseURL}/rubix/auth/adDetails`;
      this.http.get(endpoint)
        .subscribe({
          next: (value: adDetailsObject) => {
            if (value && value.success) {
              this.settings = value;
              resolve(true);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  getBrowserAuthOptions(): BrowserAuthOptions {
    // TODO: why is a global object being mutated instead of exposing settings through a service?
    // Also, the value setting here is a side effect that is unrelated to getting the auth options.
    environment.production = this.settings.production;
    environment.adClientId = this.settings.adClientId;
    environment.adTenantId = this.settings.adTenantId;
    environment.adRedirectUri = this.settings.adRedirectUri;

    return {
      authority: `https://login.microsoftonline.com/${this.settings.adTenantId}`,
      // Fall back to empty string for client id prevent BrowserAuth errors when bootstrapping
      // the app since client id is a required configuration parameter
      clientId: this.settings.adClientId ?? "",
      redirectUri: this.settings.adRedirectUri,
      postLogoutRedirectUri: '/logoutRedirect',
    }
  }
}
